import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { CreateDeliveryTaskPayload, OrderBase, OrderById } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/order`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<OrderBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<OrderBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<OrderById>> => {
  const { data } = await axiosInstance.get<ApiResponse<OrderById>>(`${BASE}/show`, {
    params: { id },
  });
  return data;
};

export const cancel = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/cancel`, { id });
  return data;
};

export const createDeliveryTask = async (payload: CreateDeliveryTaskPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    `${API_PREFIX.ADMIN_V1}/delivery-task/create`,
    payload
  );
  return data;
};
